// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { slideshowStyles } from "@steiner/Overrides/Widgets/Basic/Slideshow";
import { color, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.slideContentWrapper = {
    ...mergeWithCss(slideshowStyles.slideContentWrapper, {
        css: css`
            ${xScreen("lte", "md")} {
                height: auto;
            }
        `,
    }),
};

slideshowStyles.pictureWrapper = {
    css: css`
        ${LazyImageStyle} {
            width: 100%;
        }
        &.pointer:hover {
            cursor: pointer;
        }
    `,
};

slideshowStyles.prevArrowWrapper = {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translateY(-50%);
        left: 24px;
    `,
};

slideshowStyles.nextArrowWrapper = {
    css: css`
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translateY(-50%);
        right: 24px;
    `,
};

slideshowStyles.prevArrowButton = slideshowStyles.nextArrowButton = {
    css: css`
        background: none;
        border: 0;
        padding: 0;
        &:not(:disabled) {
            &:hover,
            &:focus {
                background: none;
                border-color: transparent;
                outline: none;

                ${IconWrapper}, svg {
                    color: ${color("common.ui9")};
                }
            }
        }
    `,
};

slideshowStyles.iconProps = {
    size: 24,
};

slideshowStyles.slideOverlayWrapper = {
    css: css`
        position: absolute;
        top: 50%;
    `,
};

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        height: 14px;
        margin-top: 8px;
    `,
};

slideshowStyles.dotButton = {
    css: css`
        width: 16px;
        height: 6px;
        min-height: 6px;
        padding: 0;
        border: none;
        background-color: ${color("common.ui4")};
        &:hover {
            background-color: ${color("common.ui9")};
        }
        &:active {
            background-color: ${color("common.ui10")};
        }
    `,
};

slideshowStyles.pauseButton = {
    css: css`
        width: 12px;
        height: 14px;
        background: none;
        border: none;
        min-height: 0;
        padding: 0;
        margin-left: 4px;

        &::after,
        &::before {
            content: "";
            height: 14px;
            width: 12px;
            background-color: ${color("common.ui4")};
            opacity: 0.5;
        }

        &::before {
            margin-right: 1px;
        }

        &.active {
            &:before {
                display: none;
            }
            &:after {
                height: 0;
                width: 0;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
                border-left: 8px solid ${color("common.ui4")};
                background-color: transparent;
            }
        }

        &:not(:disabled):focus,
        &:not(:disabled):hover {
            background: none;
            outline: none;
        }

        &:not(.active):hover {
            &::after,
            &::before {
                background-color: ${color("common.ui9")};
                opacity: 1;
            }
        }
    `,
};
